import { Application as AppEnum } from '@fides/fides-react-components';
import { ENV } from 'core/consts';
import { Environment } from 'core/enums';
import { Application } from 'core/models';
import moment from 'moment';
import { JsonObject } from '../types';

export const formatDate = (date: string, format = 'DD.MM.YYYY hh:mm:ss'): string => moment(date).format(format);

export const formatUnixTimestamp = (unixTimestamp: number, format = 'DD.MM.YYYY hh:mm:ss'): string => {
  const seconds = Math.floor(unixTimestamp);
  const milliseconds = Math.round((unixTimestamp - seconds) * 1000);
  const totalMilliseconds = seconds * 1000 + milliseconds;
  return moment(totalMilliseconds).format(format);
};

export const redirectToExternalURL = (url: string, id?: string): void => {
  const goToUrl = id ? `${url}?id=${id}` : url;
  window.location.href = goToUrl;
};

export const getAppUrl = (appName: AppEnum, appList: Application[]): string | undefined =>
  appList.find((item: Application) => (item.name as string) === appName)?.url;

export const isLocalEnv: boolean = ENV.ENVIRONMENT === Environment.LOCAL;

export const isImpersonatedUser = (json: JsonObject): boolean => json.impersonated && json.impersonatedUser !== null;

export const replaceEmptyStringsWithNulls = (object: JsonObject): JsonObject => {
  return Object.entries(object).reduce((acc, [key, value]) => {
    acc[key] = value === '' ? null : value;
    return acc;
  }, {});
};
